module.exports = __webpack_public_path__ + "img/dashboard-icon8.4706c521.svg";